import { inject } from "@angular/core";
import { RedirectCommand, ResolveFn, Router } from "@angular/router";
import { GROUP } from "@api/group/get";
import { Resolver } from "@app/services/resolver";

export const GroupResolver:ResolveFn<GROUP> = (route,state) => {
    const resolver = inject(Resolver);
    return resolver.group() ?? new RedirectCommand(inject(Router).parseUrl('/'));
}